import { chosenSites } from "app/common/services/chosenSites";
import { adaptRulesFromUrl } from "app/components/multi-include-exclude-filter/utils";
import { safeJsonParse } from "app/UtilitiesAndConstants/UtilityFunctions/safeJsonParse";

import type { ITabData } from "./searchAdsWebsiteTypes";

const URL_DELIMITER = "/";

export const getSiteData = (pageFilter: string): ITabData[] => {
    const pagesParam = JSON.parse(pageFilter ?? "[]");
    const domainList = pagesParam.map((page) => ({ ...page, domain: page.url.split(URL_DELIMITER)?.[0] }));
    const sitesData = domainList.map((site) => ({ ...site, ...chosenSites.getInfo(site.domain) }));

    return sitesData.map((siteData, index) => {
        return {
            id: `${siteData.name}_${index}`,
            title: siteData.url,
            icon: siteData.icon,
            reverseEllipsis: siteData.searchType !== "domain" && siteData.searchType !== "subdomain",
        };
    });
};

export const adaptMultiIncludeExcludeRules = async (filter: string): Promise<string> => {
    const parsedFilter = safeJsonParse(filter, []);
    const adaptedRules = await adaptRulesFromUrl(parsedFilter);
    return JSON.stringify(adaptedRules);
};
